import React from 'react';
import { Card, CardContent } from '@mui/material';
import GeneralData from './generalData';

// A configuração de templates de receituário foi movida para "Configurações Gerais".
// Esta tela cuida apenas dos dados de identidade da clínica.
export default function ClinicSettings() {
  return (
    <Card>
      <CardContent>
        <GeneralData />
      </CardContent>
    </Card>
  );
}
